<p-autoComplete
  [formControl]="searchControl"
  [suggestions]="suggestions()"
  (completeMethod)="onSearch($event.query)"
  (onSelect)="onSuggestionSelected($event)"
  (onBlur)="markAsTouched()"
  placeholder="Ej: Cursor"
  class="w-full block"
  styleClass="w-full"
  [inputStyle]="{ width: '100%' }"
  optionLabel="name"
  [forceSelection]="false"
  [minLength]="3"
  [delay]="300"
  [showEmptyMessage]="true">
  <ng-template
    #item
    let-option>
    <span>
      <span>{{ option.name }}</span>
    </span>
  </ng-template>

  <ng-template #empty>
    <span>{{ loading() ? 'Buscando soluciones...' : 'No se encontraron coincidencias' }}</span>
  </ng-template>

  <ng-template #footer>
    <button
      *ngIf="shouldShowAddAction()"
      type="button"
      class="solution-add-option"
      (mousedown)="$event.preventDefault()"
      (click)="addCurrentTextAsNewSolution()">
      <i
        class="pi pi-plus solution-add-option__icon"
        aria-hidden="true"></i>
      <span>A&ntilde;adir soluci&oacute;n IA</span>
    </button>
  </ng-template>
</p-autoComplete>

<span
  class="sr-only"
  aria-live="polite">
  {{ loading() ? 'Buscando soluciones' : '' }}
</span>
